import React, { memo, useEffect } from 'react';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import OrgEmployeeFamilySalePageData from '../../../Models/Content/OrgEmployeeFamilySalePageData';
import { getOrgFamilyBenefitsAllocations } from './OrgEmployeeFamilySaleSlice.js';
import { connect } from 'react-redux';

// ContentArea recreates EpiComponent types on every render; memo keeps blocks mounted.
const MemoizedContentArea = memo(function MemoizedContentArea({ context, data, propertyName }) {
  return (
    <ContentArea
      context={context}
      data={data}
      propertyName={propertyName}
    />
  );
});

function OrgEmployeeFamilySaleMain({context, iContent, ...props}) {
  const hasSupportWorldsBlock = iContent.mainContentArea?.expandedValue?.some(
    (item) => item.contentType?.[1] === 'SupportWorldsBlock'
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    if (hasSupportWorldsBlock) {
      getFamilyBenefitsAllocations();
    }
  }, []);

  const getFamilyBenefitsAllocations = async () => {
    await props.getOrgFamilyBenefitsAllocations();
  };

  return (
    <div className='org-employee-family-sale-page'>
      <MemoizedContentArea
        context={context}
        data={iContent.mainContentArea}
        propertyName='mainContentArea'
      />
    </div>
  );
}

const mapDispatchToProps = {
  getOrgFamilyBenefitsAllocations,
};

export default connect(null, mapDispatchToProps)(OrgEmployeeFamilySaleMain);
